// 一个表示对象类型的字符串
const toString = Object.prototype.toString;

/**
 * 是否为指定的字符串类型
 * @param val
 * @param type
 */
export const is = (val: unknown, type: string) => {
  return toString.call(val) === `[object ${type}]`;
};

/**
 * 一个值是否为undefined
 * @param val
 */
export const isDef = <T = unknown>(val?: T): val is T => {
  return typeof val !== "undefined";
};

/**
 * 判断一个参数是否为未定义(undefied)
 * @param val
 */
export const isUnDef = <T = unknown>(val?: T): val is T => {
  return !isDef(val);
};

/**
 * 判断一个参数是否为对象
 * @param val
 */
export const isObject = (val: any): val is Record<any, any> => {
  return val !== null && is(val, "Object");
};

/**
 * 判断一个参数是否为null
 * @param val
 */
export const isNull = (val: unknown): val is null => {
  return val === null;
};

/**
 * 判断一个值是否为null和undefined
 * @param val
 */
export const isNullAndUnDef = (val: unknown): val is null | undefined => {
  return isUnDef(val) && isNull(val);
};

/**
 * 判断一个值是否为数字类型
 * @param val
 */
export const isNumber = (val: unknown): val is number => {
  return is(val, "Number");
};
/**
 * 判断参数是否为字符串类型
 * @param val
 */
export const isString = (val: unknown): val is string => {
  return is(val, "String");
};

/**
 * 判断参数是否为方法类型
 * @param val
 */
export const isFunction = (val: unknown): val is Function => {
  return typeof val === "function";
};

/**
 * 判断参数是否为Boolean类型
 * @param val
 */
export const isBoolean = (val: unknown): val is boolean => {
  return is(val, "Boolean");
};

/**
 * 是否为数组类型
 * @param val
 */
export const isArray = (val: any): val is Array<any> => {
  return val && Array.isArray(val);
};

/**
 *  判断一个值是否为空
 * @param val
 */
export const isEmpty = <T = unknown>(val: T): val is T => {
  if (isArray(val) || isString(val)) {
    return val.length === 0;
  }

  if (val instanceof Map || val instanceof Set) {
    return val.size === 0;
  }

  if (isObject(val)) {
    return Object.keys(val).length === 0;
  }

  return false;
};

/**
 * 检测当前代码环境是否运行在浏览器中。
 */
export const isServer = typeof window === "undefined";

export const isClient = !isServer;

/**
 * 否为合法的URL字符串
 * @param path
 */
export const isUrl = (path: string): boolean => {
  const reg = /(((^https?:(?:\/\/)?)(?:[-:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&%@.\w_]*)#?(?:[\w]*))?)$/;
  return reg.test(path);
};

/**
 * 是否是图片链接
 * @param path
 */
export const isImgPath = (path: string): boolean => {
  return /(https?:\/\/|data:image\/).*?\.(png|jpg|jpeg|gif|svg|webp|ico)/gi.test(path);
};

/**
 * 值是否为空
 * @param val
 */
export const isEmptyVal = (val: any): boolean => {
  return val === "" || val === null || val === undefined;
};

export const isMobile = (): boolean => {
  return /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(navigator.userAgent);
};
